import toast from 'react-hot-toast';

/**
 * Format an Axios/FastAPI error into a human-readable string.
 *
 * FastAPI returns validation errors as an array of `{type, loc, msg, input}`
 * under `response.data.detail`; HTTPException returns `detail` as a string.
 */
export const formatApiError = (error: unknown, fallback = 'An error occurred'): string => {
  const e = error as { response?: { data?: { detail?: unknown } }; message?: string } | null;
  const detail = e?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => {
        const loc = Array.isArray(d?.loc) ? d.loc.filter((p: unknown) => p !== 'body').join('.') : '';
        const msg = d?.msg ?? 'invalid';
        return loc ? `${loc}: ${msg}` : msg;
      })
      .join('; ');
  }
  return e?.message || fallback;
};

/** Toast a formatted API error. */
export const toastApiError = (error: unknown, fallback?: string): void => {
  toast.error(formatApiError(error, fallback));
};
